export class DashboardRoutingConstants {
    static MODULES_ROUTE = "modules";
}
